import React, {useEffect, useState} from 'react';
import {
  Bar,
  BarChart,
  Cell,
  LabelList,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import {faker} from '@faker-js/faker';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import PieChartIcon from '@mui/icons-material/PieChart';
import BarChartIcon from '@mui/icons-material/BarChart';
import Grid from '@mui/material/Grid';
import {QUESTION_TYPES} from '../../constants/appConstants';

const getBarColors = (questionType) => {
if (questionType === QUESTION_TYPES.QUIZ) {
    return ['#2ca02c', '#d62728']
  }
  return ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2']
}

const labelFormatter = (value, onlyPercentage, questionType) => {
  const showMarkArray = ['✔', '']
  if (questionType === QUESTION_TYPES.QUIZ) {
    showMarkArray.push('❌')
  }
  const showMark = faker.helpers.arrayElement(showMarkArray)

  if (onlyPercentage) {
    return `${faker.number.int({min: 10, max: 40})}%`
  }
  return `${showMark} ${value} - ${faker.number.int({min: 10, max: 40})}%`
}
export default function ResultsChart({options, questionType}) {

  const [chartData, setChartData] = useState([])
  const [isPieChart, setIsPieChart] = useState(false)
  const barColors = getBarColors(questionType);
  useEffect(() => {
    if (options) {
      setChartData(options.map(option => {
        return {
          name: option,
          value: faker.number.int({min: 100, max: 1000}),
        }
      }))
    } else {
      setChartData([])
    }
  }, [options])

  const renderBarChart = () => {
    return <div style={{width: window.screen.width - 50, height: 200}}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          layout={'vertical'}
          width={150} height={40} data={chartData}
          margin={{top: 5, right: 5, bottom: 5, left: 5}}>
          <XAxis type="number" hide>
          </XAxis>
          <Bar dataKey="value"
               fill="#ff6f31"
               barSize={10}
               radius={30}
               animationDuration={1000}
               animationEasing={'linear'}
          >
            <LabelList dataKey="name"
                       width={300}
                       position="top"
                       formatter={(value) => labelFormatter(value, false, questionType)}
            />
            {
              chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={barColors[index % 20]}/>
              ))
            }
          </Bar>
          <YAxis dataKey="name" hide type="category"/>
        </BarChart>
      </ResponsiveContainer>
    </div>
  }

  const renderPieChart = () => {
    return <div style={{width: window.screen.width - 50, height: 200}}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            dataKey="value"
            isAnimationActive={false}
            data={chartData}
            cx="50%"
            cy="50%"
            innerRadius={40}
            outerRadius={80}
            label
          >
            <LabelList dataKey="name"
                       width={300}
                       position="top"
                       formatter={(value) => labelFormatter(value, true, questionType)}
            />
            {
              chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={barColors[index % 20]}/>
              ))
            }
          </Pie>
          <Tooltip/>
          <Legend/>
        </PieChart>
      </ResponsiveContainer>
    </div>
  }
  return (
    <>
      <Grid container justifyContent="flex-end">
        <ButtonGroup aria-label="outlined primary button group" sx={{mr: 1, mt: 1}}>
          <Button variant={isPieChart ? 'outlined' : 'contained'} startIcon={<BarChartIcon/>}
                  onClick={() => setIsPieChart(false)}/>
          <Button variant={isPieChart ? 'contained' : 'outlined'} startIcon={<PieChartIcon/>}
                  onClick={() => setIsPieChart(true)}/>
        </ButtonGroup>
      </Grid>
      {isPieChart ? renderPieChart() : renderBarChart()}
    </>
  );
}
